function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_2283_249159)"
}, React.createElement("path", {
  d: "M10.0007 3.19998C8.4364 3.56262 6.99761 4.33718 5.83358 5.44332C4.66954 6.54946 3.82264 7.94689 3.38072 9.49066C2.93881 11.0344 2.91798 12.6683 3.32039 14.2229C3.72279 15.7774 4.53378 17.196 5.66924 18.3314C6.8047 19.4669 8.22327 20.2779 9.77781 20.6803C11.3323 21.0827 12.9662 21.0619 14.51 20.62C16.0538 20.178 17.4512 19.3311 18.5574 18.1671C19.6635 17.0031 20.4381 15.5643 20.8007 14C20.8007 13.7348 20.6953 13.4804 20.5078 13.2929C20.3203 13.1053 20.0659 13 19.8007 13H13.0007C12.4703 13 11.9616 12.7893 11.5865 12.4142C11.2114 12.0391 11.0007 11.5304 11.0007 11V3.99998C10.9883 3.88151 10.9525 3.76668 10.8953 3.66215C10.8382 3.55763 10.7608 3.46548 10.6678 3.39107C10.5748 3.31665 10.4679 3.26144 10.3534 3.22864C10.2389 3.19584 10.119 3.1861 10.0007 3.19998Z",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M15 3.5C16.2697 3.94708 17.423 4.6733 18.3748 5.62516C19.3267 6.57702 20.0529 7.73028 20.5 9H16C15.7348 9 15.4804 8.89464 15.2929 8.70711C15.1054 8.51957 15 8.26522 15 8V3.5Z",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_2283_249159"
}, React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgIconShowChartLight = function SvgIconShowChartLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconShowChartLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_show_chart_light.68b5813b.svg";
export { ForwardRef as ReactComponent };